/**
 * @file 文章页
 * @author wangzhuang
 */

import {rcAjax} from '../util';
import {GET_CMSAPI_GETARTICLEDATA, GET_CMSAPI_ZAN} from './ActionTypes';

export function fetchCmsapiGetArticleData(dispatch, aidObj) {
    return rcAjax('GET', '/cmsapi/getArticleData', aidObj, {}, data => {
        dispatch({type: GET_CMSAPI_GETARTICLEDATA, data: data.data});
    });
}

export function fetchCmsapiZan(dispatch, aidObj) {
    return rcAjax('GET', '/cmsapi/zan', aidObj, {}, data => {
        dispatch({type: GET_CMSAPI_ZAN, data: data.data});
    });
}



// WEBPACK FOOTER //
// ./src/actions/pageAction.js